import { ProjectDto } from '@/core';
import { tabsSettings } from '../hooks';

type validateConstructorType = {
  isValid: boolean;
  isStepAvailable: boolean;
};

type ValidatorType = {
  [key: string]: validateConstructorType;
};

const checkIsStepAvailable = (obj: ValidatorType, index: number) => {
  const { tabName } = tabsSettings[index] ?? {};
  const { isStepAvailable, isValid } = obj[tabName] ?? {};
  return isStepAvailable && isValid;
};

export const validateConstructor = (projectData: ProjectDto) => {
  return tabsSettings.reduce((acc, tab, index) => {
    acc[tab.tabName] = {
      isValid: tab.validateFunction(projectData),
      isStepAvailable: checkIsStepAvailable(acc, index - 1) || projectData.isCompleted || index === 0,
    };
    return acc;
  }, {} as ValidatorType);
};
